import { Pipe, PipeTransform, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { dateUtil } from "src/app/support/date-util";
import { RegionService } from "src/app/services/feature-access-control/region.service";
import { sntTranslate } from "src/app/support/translate";

@Pipe({
  name: "todayOrDate",
  standalone: false
})
export class TodayOrDatePipe implements PipeTransform {
  private readonly regionService = inject(RegionService);

  transform(
    value: any,
    options?: {
      parseFormat?: string;
      useToday?: boolean;
      useLongDates?: boolean;
    }
  ): string {
    const dayjsDate = dateUtil(value, options?.parseFormat).locale(
      this.regionService.getLocale()
    );

    if (dayjsDate.isSame(dateUtil(), "day")) {
      return options?.useToday
        ? sntTranslate(marker("Oggi"))
        : dayjsDate.format("HH:mm");
    }

    if (dayjsDate.isSame(dateUtil().add(-1, "day"), "day")) {
      return sntTranslate(marker("Ieri"));
    }

    if (dayjsDate.isAfter(dateUtil().add(-7, "day"))) {
      return dayjsDate.format("dddd");
    }

    if (dayjsDate.isSame(dateUtil(), "year")) {
      return options?.useLongDates
        ? dayjsDate.format("dddd DD MMMM YYYY")
        : dayjsDate.format("DD/MM");
    }

    return dayjsDate.format("DD/MM/YYYY");
  }
}
